import { render, staticRenderFns } from "./WaterSupplyHydrologicalDataReservoirs.vue?vue&type=template&id=0279ada0&scoped=true"
import script from "./WaterSupplyHydrologicalDataReservoirs.vue?vue&type=script&lang=js"
export * from "./WaterSupplyHydrologicalDataReservoirs.vue?vue&type=script&lang=js"
import style0 from "./WaterSupplyHydrologicalDataReservoirs.vue?vue&type=style&index=0&id=0279ada0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279ada0",
  null
  
)

export default component.exports